import { LifecycleEnum } from "@boundless/bl-api-client/customer/models"

type SigningDocument = {
  lifecycle: LifecycleEnum
  canSendForSignatures: boolean
  canSign: boolean
  providerError: boolean
  signerEvidenceInvalid: boolean
  signerSigned: boolean | null
  signingUrl: string | null
  stale: boolean
}

export type SigningPageState =
  | { status: "ready-to-send" }
  | { status: "sending-unavailable" }
  | { status: "sending" }
  | {
      status: "pending"
      signingUrl: string | null
      signerEvidenceInvalid: boolean
      signerSigned: boolean | null
      stale: boolean
      providerError: boolean
    }
  | { status: "signed" }
  | { status: "declined" }

export function projectSigningPageState(
  document: SigningDocument,
  isSending: boolean,
): SigningPageState {
  const lifecycle = isSending ? LifecycleEnum.sending : document.lifecycle

  switch (lifecycle) {
    case LifecycleEnum.not_sent:
      return document.canSendForSignatures
        ? { status: "ready-to-send" }
        : { status: "sending-unavailable" }
    case LifecycleEnum.sending:
      return { status: "sending" }
    case LifecycleEnum.pending:
      return {
        status: "pending",
        signingUrl: document.canSign ? document.signingUrl : null,
        signerEvidenceInvalid: document.signerEvidenceInvalid,
        signerSigned: document.signerSigned,
        stale: document.stale,
        providerError: document.providerError,
      }
    case LifecycleEnum.signed:
      return { status: "signed" }
    case LifecycleEnum.declined:
      return { status: "declined" }
  }
}
